import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
import Slick from "components/Antd/Slick";
import cx from "classnames";
import styles from "./index.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";
import { get_product } from "@/api/v4/finance";
import NoData from "@/components/App/div/noData";
import XtLoading from "@/components/Xt/Loading";
import stylesProducts from "@/components/Pages/Finance/Styles/products.module.less";
import DropDuration from "@/components/Pages/Finance/Drop/Duration";
import CurrencySelect from "@/components/Pages/Finance/_cmpt/CurrencySelect";
import Row from "./Row";
import DropSelect from "@/components/Pages/Finance/Drop/Select";
import XtSvg from "@/components/Xt/Svg";

export default observer(() => {
  const t = useTranslation();
  const { finance } = useStore();

  const limit = 10000;
  const fromPage = useRef(1);

  const [loading, setLoading] = useState(false);
  const [resData, setResData] = useState([]);

  const [filterSelect, setFilterSelect] = useState([]);
  const [currency, setCurrency] = useState();

  const [hasMore, setHasMore] = useState(false);

  const apiReq = useCallback(
    (isMore) => {
      if (loading) return;
      setLoading(true);
      if (!isMore) fromPage.current = 1;

      get_product({
        params: {
          categories: "STAKING",
          financeProductType: "LAUNCH_POOL",
          available: filterSelect.includes("displayAvailableOnly") ? true : undefined,
          matchMyAssets: filterSelect.includes("matchMyAssets") ? true : undefined,
          myStaked: filterSelect.includes("myStakedPoolsOnly") ? true : undefined,
          currency,
          limit,
          fromPage: fromPage.current + (isMore ? 1 : 0),
        },
        errorPop: true,
      })
        .then((result) => {
          /*
          result = {
            hasPrev: false,
            hasNext: false,
            items: [
              {
                groupTag: "btc",
                productCollections: [
                  {
                    category: "STAKING",
                    financialProducts: [
                      {
                        id: 6,
                        tenantId: 1,
                        productType: "PROMOTIONS",
                        currencyId: 2,
                        currency: "usdt",
                        currencyPrecision: 10,
                        totalQuota: 1000,
                        individualCap: 3,
                        singleMin: 0.01,
                        singleMax: 1,
                        profitType: "GRADING",
                        apyList: [
                          {
                            level: 1.1,
                            annualized: 8.3,
                          },
                          {
                            level: 2.1,
                            annualized: 9.3,
                          },
                        ],
                        systemTag: "NEW",
                        available: true,
                        autoEnable: false,
                        duration: 100,
                        noviceExclusive: false,
                        subscribeStartTime: 1695613309126,
                        subscribeEndTime: 1698205330791,
                        workStartTime: 1699933356625,
                        financeProductStatus: "WARMING",
                        interestCurrencyId: 11,
                        interestCurrency: "BTC",
                        totalReward: 600,
                        rewardPercent: 21.1,
                        officialSite: "abc",
                        whitePaperSite: "abc",
                        regulationSite: "abc",
                        enableRedemption: false,
                        groupId: 121,
                        productNames: [
                          {
                            language: "en",
                            name: "eth-fix",
                          },
                        ],
                        productPrice: 0,
                        enableStaking: false,
                        stakingPercent: 0,
                        hashRatePerShare: 0,
                        hashRateUnit: "string",
                        managementFee: 0,
                        dailyMinOutput: 0,
                        dailyMaxOutput: 0,
                        dailyActualOutput: 0,
                        stakingCurrencyId: 0,
                        stakingCurrency: "string",
                        category: "SAVING",
                        recommended: false,
                        weight: null,
                        customTags: [
                          {
                            language: "en",
                            name: "all-in",
                          },
                        ],
                        creator: "alex",
                        createdTime: 1693885510021,
                        updater: null,
                        updatedTime: 1693885510021,
                        subscribed: null,
                        workEndTime: 1708573356625,
                      },
                      {
                        id: 1,
                        tenantId: 1,
                        productType: "FLEXIBLE",
                        currencyId: 2,
                        currency: "BTC",
                        currencyPrecision: 10,
                        totalQuota: 1000,
                        individualCap: 3,
                        singleMin: 0.01,
                        singleMax: 1,
                        profitType: "NORMAL",
                        apyList: [
                          {
                            level: 1.2,
                            annualized: 10.3,
                          },
                        ],
                        systemTag: "HOT",
                        available: true,
                        autoEnable: false,
                        duration: 100,
                        noviceExclusive: false,
                        subscribeStartTime: 1695613309126,
                        subscribeEndTime: 1698205330791,
                        workStartTime: 1699933356625,
                        financeProductStatus: null,
                        interestCurrencyId: 2,
                        interestCurrency: "BTC",
                        totalReward: 0,
                        rewardPercent: 0,
                        officialSite: "string",
                        whitePaperSite: "string",
                        regulationSite: "string",
                        enableRedemption: true,
                        groupId: 0,
                        productNames: [
                          {
                            language: "en",
                            name: "btc-flexible",
                          },
                        ],
                        productPrice: 0,
                        enableStaking: true,
                        stakingPercent: 0,
                        hashRatePerShare: 0,
                        hashRateUnit: "string",
                        managementFee: 0,
                        dailyMinOutput: 0,
                        dailyMaxOutput: 0,
                        dailyActualOutput: 0,
                        stakingCurrencyId: 0,
                        stakingCurrency: "string",
                        category: "SAVING",
                        recommended: true,
                        weight: 10,
                        customTags: [
                          {
                            language: "en",
                            name: "all-in",
                          },
                        ],
                        creator: "alex",
                        createdTime: 1693885510021,
                        updater: null,
                        updatedTime: 1693885510021,
                        subscribed: null,
                        workEndTime: 1708573356625,
                      },
                      {
                        id: 2,
                        tenantId: 1,
                        productType: "FLEXIBLE",
                        currencyId: 2,
                        currency: "BTC",
                        currencyPrecision: 10,
                        totalQuota: 1000,
                        individualCap: 3,
                        singleMin: 0.01,
                        singleMax: 1,
                        profitType: "NORMAL",
                        apyList: [
                          {
                            level: 1.2,
                            annualized: 10.3,
                          },
                        ],
                        systemTag: "HOT",
                        available: true,
                        autoEnable: false,
                        duration: 100,
                        noviceExclusive: false,
                        subscribeStartTime: 1695613309126,
                        subscribeEndTime: 1698205330791,
                        workStartTime: 1699933356625,
                        financeProductStatus: null,
                        interestCurrencyId: 2,
                        interestCurrency: "BTC",
                        totalReward: 0,
                        rewardPercent: 0,
                        officialSite: "string",
                        whitePaperSite: "string",
                        regulationSite: "string",
                        enableRedemption: true,
                        groupId: 0,
                        productNames: [
                          {
                            language: "en",
                            name: "btc-flexible",
                          },
                        ],
                        productPrice: 0,
                        enableStaking: true,
                        stakingPercent: 0,
                        hashRatePerShare: 0,
                        hashRateUnit: "string",
                        managementFee: 0,
                        dailyMinOutput: 0,
                        dailyMaxOutput: 0,
                        dailyActualOutput: 0,
                        stakingCurrencyId: 0,
                        stakingCurrency: "string",
                        category: "SAVING",
                        recommended: false,
                        weight: 10,
                        customTags: [
                          {
                            language: "en",
                            name: "all-in",
                          },
                        ],
                        creator: "alex",
                        createdTime: 1693885510021,
                        updater: null,
                        updatedTime: 1693885510021,
                        subscribed: null,
                        workEndTime: 1708573356625,
                      },
                      {
                        id: 3,
                        tenantId: 1,
                        productType: "FLEXIBLE",
                        currencyId: 2,
                        currency: "BTC",
                        currencyPrecision: 10,
                        totalQuota: 1000,
                        individualCap: 3,
                        singleMin: 0.01,
                        singleMax: 1,
                        profitType: "NORMAL",
                        apyList: [
                          {
                            level: 1.2,
                            annualized: 10.3,
                          },
                        ],
                        systemTag: "HOT",
                        available: true,
                        autoEnable: false,
                        duration: 100,
                        noviceExclusive: false,
                        subscribeStartTime: 1695613309126,
                        subscribeEndTime: 1698205330791,
                        workStartTime: 1699933356625,
                        financeProductStatus: null,
                        interestCurrencyId: 2,
                        interestCurrency: "BTC",
                        totalReward: 0,
                        rewardPercent: 0,
                        officialSite: "string",
                        whitePaperSite: "string",
                        regulationSite: "string",
                        enableRedemption: true,
                        groupId: 0,
                        productNames: [
                          {
                            language: "en",
                            name: "btc-flexible",
                          },
                        ],
                        productPrice: 0,
                        enableStaking: true,
                        stakingPercent: 0,
                        hashRatePerShare: 0,
                        hashRateUnit: "string",
                        managementFee: 0,
                        dailyMinOutput: 0,
                        dailyMaxOutput: 0,
                        dailyActualOutput: 0,
                        stakingCurrencyId: 0,
                        stakingCurrency: "string",
                        category: "SAVING",
                        recommended: false,
                        weight: 10,
                        customTags: [
                          {
                            language: "en",
                            name: "all-in",
                          },
                        ],
                        creator: "alex",
                        createdTime: 1693885510021,
                        updater: null,
                        updatedTime: 1693885510021,
                        subscribed: null,
                        workEndTime: 1708573356625,
                      },
                    ],
                  },
                ],
              },
            ],
          };
           */

          setResData(isMore ? [...resData, ...result.items] : result.items || []);
          setHasMore(result.hasNext);
          isMore && (fromPage.current = fromPage.current + 1);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [resData, loading, filterSelect, currency]
  );

  useEffect(() => {
    apiReq();
  }, [filterSelect, currency]);

  const onViewMore = useCallback(() => {
    apiReq(true);
  }, [apiReq]);

  const [isExpand, setIsExpand] = useState(false);
  const isMoreBtn = useMemo(() => resData.length > 4, [resData]);
  const onMoreBtnClick = useCallback(() => setIsExpand(!isExpand), [isExpand]);
  const items = useMemo(() => resData.slice(0, isExpand ? undefined : 4), [resData, isExpand]);

  return (
    <div className={styles.main}>
      <h2 className={styles.title}>{t("finance.Launchpool")}</h2>

      <div className={styles.content}>
        <div className={stylesProducts.filterCon}>
          <div>
            <DropSelect type={"Launchpool"} data={filterSelect} callback={setFilterSelect} />
          </div>
          <div>
            <CurrencySelect className={stylesProducts.search} value={currency} onChange={setCurrency} />
          </div>
        </div>

        <div className={cx(stylesProducts.bodyCon, styles.content)}>
          {loading && <XtLoading />}
          {!items.length && <NoData className={styles.noData} />}

          {!!items.length && (
            <>
              {items.map((data) => (
                <Row key={data.groupTag} data={data} />
              ))}

              {isMoreBtn && (
                <div className={stylesProducts.more}>
                  <button className={cx("btnTxt")} onClick={onMoreBtnClick}>
                    <span>{isExpand ? t("finance.collapse") : t("cmpt.viewmore")}</span>
                    <XtSvg icon={"doubleArrow"} style={{ marginLeft: "5px", transform: isExpand ? "rotateZ(-90deg)" : "rotateZ(90deg)" }} />
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
});
